export default function (props: any) {
    return (
        <svg
            width="27px"
            height="26px"
            viewBox="0 0 27 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Offcial-Online-Stroes备份" transform="translate(-186.000000, -576.000000)">
                    <g id="编组" transform="translate(186.437500, 576.000000)">
                        <path
                            d="M0,1.625 C0,0.727536875 0.612662632,0 1.36842105,0 L24.6315789,0 C25.3873579,0 26,0.727536875 26,1.625 L26,24.375 C26,25.2724875 25.3873579,26 24.6315789,26 L1.36842105,26 C0.612662632,26 0,25.2724875 0,24.375 L0,1.625 Z"
                            id="路径"
                        ></path>
                        <path
                            d="M15.5625,7.39448791 L15.5645,7.49932088 L2.5625,7.5 C2.31703989,7.5 2.11289158,7.67687496 2.07055566,7.9101243 L2.0625,8 L2.0625,22 C2.0625,22.2761513 2.28635103,22.5 2.5625,22.5 L19.5625,22.5 C19.8386576,22.5 20.0625,22.2761576 20.0625,22 L20.0625,11.8944879 C20.406534,11.8944879 20.7415508,11.8558809 21.0634543,11.782763 L21.0625,22 C21.0625,22.8284424 20.3909424,23.5 19.5625,23.5 L2.5625,23.5 C1.7340686,23.5 1.0625,22.8284384 1.0625,22 L1.0625,8 C1.0625,7.17157263 1.73407263,6.5 2.5625,6.5 L15.651538,6.49932088 C15.5931449,6.78862124 15.5625,7.08797582 15.5625,7.39448791 Z"
                            id="形状结合"
                            fill="#919191"
                            fillRule="nonzero"
                        ></path>
                        <circle id="椭圆形备份" stroke="#979797" fillRule="nonzero" cx="20.0625" cy="7.39448791" r="4.5"></circle>
                        <path
                            d="M20.5625,5.5 L22.5625,7.5 L20.5625,9.5 L20.5615,7.999 L17.5625,8 L17.5625,7 L20.5625,7 L20.5625,5.5 Z"
                            id="形状结合"
                            fill="#979797"
                            transform="translate(20.062500, 7.500000) rotate(-270.000000) translate(-20.062500, -7.500000) "
                        ></path>
                        <path
                            d="M6.3125,12.25 C6.86476667,12.25 7.3125,11.8022667 7.3125,11.25 C7.3125,10.6977333 6.86476667,10.25 6.3125,10.25 C5.76023333,10.25 5.3125,10.6977333 5.3125,11.25 C5.3125,11.8022667 5.76023333,12.25 6.3125,12.25 Z"
                            id="路径"
                            fill="#919191"
                        ></path>
                        <path
                            d="M6.5625,15 L9.0625,17 L12.0625,13.5 L20.5625,20 L20.5625,22 C20.5625,22.5523 20.1148,23 19.5625,23 L2.5625,23 C2.010215,23 1.5625,22.5523 1.5625,22 L1.5625,20 L6.5625,15 Z"
                            id="路径"
                            stroke="#919191"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
